// export const BASE_URL = "http://175.101.36.61:8001/api";
export const S3_URL = 'https://swift-carry-dev.s3.amazonaws.com';
// export const BASE_URL = "https://api.swiftcarry.in/admin/api";
export const BASE_URL = 'https://api.swiftcarry.in/admin/api';
// "https://api.swiftcarry.in/admin/api";
